import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="age-restriction">
          <div className="age-badge">18+</div>
          <p>This site is intended for adults 18 years or older</p>
        </div>
        
        <div className="footer-info">
          <p className="copyright">
            © {currentYear} iGames.ng. All rights reserved.
          </p>
          <p className="disclaimer">
            All games are provided for entertainment purposes only. 
            Play responsibly.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
